/* Elizalde collection grid (watch and jewelry pages) */
(function () {
  'use strict';
  var STOCK_KEY = 'wrAllStock';
  var current = new URLSearchParams(window.location.search);
  var VIEW = current.get('view');

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function store(fn) { try { return fn(); } catch (e) { return null; } }

  /* Keep an alternate template (?view=) while browsing, e.g. during theme preview */
  function withView(href) {
    if (!VIEW || !href) return href;
    var u = new URL(href, window.location.origin);
    if (u.origin !== window.location.origin || u.pathname !== window.location.pathname) return href;
    u.searchParams.set('view', VIEW);
    return u.pathname + u.search + u.hash;
  }
  function keepView(root) {
    if (!VIEW) return;
    qsa('a[href]', root).forEach(function (a) {
      var h = a.getAttribute('href');
      if (h && h.charAt(0) !== '#') a.setAttribute('href', withView(h));
    });
  }

  /* Show in-stock pieces by default, once per visit, unless the shopper chose otherwise */
  function stockDefault(root) {
    var addUrl = root.getAttribute('data-instock-url');
    if (!addUrl || (window.Shopify && window.Shopify.designMode)) return;
    var hasFilter = false;
    current.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
    if (hasFilter || current.get('page')) return;
    if (store(function () { return window.sessionStorage.getItem(STOCK_KEY); }) === '1') return;
    var target = new URL(addUrl, window.location.origin);
    if (current.get('sort_by')) target.searchParams.set('sort_by', current.get('sort_by'));
    if (VIEW) target.searchParams.set('view', VIEW);
    window.location.replace(target.pathname + target.search + window.location.hash);
  }

  function bindStockToggles(root) {
    qsa('[data-wr-stock-toggle]', root).forEach(function (el) {
      el.addEventListener('click', function () {
        var turningOff = el.getAttribute('data-on') === 'true';
        store(function () {
          if (turningOff) window.sessionStorage.setItem(STOCK_KEY, '1');
          else window.sessionStorage.removeItem(STOCK_KEY);
        });
      });
    });
    qsa('[data-wr-clear-all]', root).forEach(function (el) {
      el.addEventListener('click', function () { store(function () { window.sessionStorage.setItem(STOCK_KEY, '1'); }); });
    });
  }

  function bindSort(root) {
    qsa('[data-wr-sort]', root).forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        url.hash = 'shop';
        window.location.href = url.toString();
      });
    });
  }

  function bindFilters(root) {
    qsa('[data-wr-filters]', root).forEach(function (form) {
      function go() {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (value, key) { if (String(value).trim() !== '') params.append(key, value); });
        if (VIEW) params.set('view', VIEW);
        var qs = params.toString();
        window.location.href = form.getAttribute('action') + (qs ? '?' + qs : '') + '#shop';
      }
      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'checkbox') go();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    });
    qsa('[data-wr-more]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.previousElementSibling;
        if (!list) return;
        var collapsed = list.classList.toggle('is-collapsed');
        btn.textContent = collapsed ? btn.getAttribute('data-more') : btn.getAttribute('data-less');
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    });
  }

  function bindDrawer(root) {
    var side = root.querySelector('[data-wr-side]');
    var scrim = root.querySelector('[data-wr-scrim]');
    if (!side) return;
    var opener = null;
    function onKey(e) { if (e.key === 'Escape') toggle(false); }
    function toggle(open) {
      side.classList.toggle('is-open', open);
      if (scrim) scrim.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      qsa('[data-wr-open-filters]', root).forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        document.addEventListener('keydown', onKey);
        var first = side.querySelector('[data-wr-close-filters]');
        if (first) first.focus();
      } else {
        document.removeEventListener('keydown', onKey);
        if (opener) opener.focus();
      }
    }
    qsa('[data-wr-open-filters]', root).forEach(function (b) {
      b.addEventListener('click', function () { opener = b; toggle(true); });
    });
    qsa('[data-wr-close-filters]', root).forEach(function (b) {
      b.addEventListener('click', function () { toggle(false); });
    });
    if (scrim) scrim.addEventListener('click', function () { toggle(false); });
  }

  /* Fetch the next page of products into the grid. Resolves true when more pages remain. */
  function loadNext(root, btn) {
    var url = btn.getAttribute('href');
    var sectionId = btn.getAttribute('data-section-id');
    return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-wr-grid]');
        qsa('[data-wr-grid] > .wr-card', doc).forEach(function (card) {
          var node = document.importNode(card, true);
          keepView(node);
          grid.appendChild(node);
        });
        var offset = parseInt(btn.getAttribute('data-offset') || '0', 10);
        var total = parseInt(btn.getAttribute('data-total') || '0', 10);
        var shown = offset + grid.querySelectorAll('.wr-card').length;
        var shownEl = root.querySelector('[data-wr-shown]');
        if (shownEl) shownEl.textContent = shown.toLocaleString('en-US');
        var bar = root.querySelector('[data-wr-bar]');
        if (bar && total) bar.style.width = Math.max(3, Math.min(100, Math.round(shown / total * 100))) + '%';
        var next = doc.querySelector('[data-wr-load-more]');
        if (next) {
          btn.setAttribute('href', withView(next.getAttribute('href')));
          return true;
        }
        btn.parentNode.removeChild(btn);
        return false;
      });
  }

  function bindLoadMore(root) {
    qsa('[data-wr-load-more]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var url = btn.getAttribute('href');
        if (!url || !window.fetch || !window.DOMParser) return;
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        var label = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = btn.getAttribute('data-loading-label') || 'Loading';
        loadNext(root, btn)
          .then(function (more) {
            if (more) {
              btn.textContent = label;
              btn.removeAttribute('aria-busy');
            }
          })
          .catch(function () { window.location.href = url; });
      });
    });
  }

  /* Size and fit filtering done in the page: ring size, chain length and chain width */
  var FIT_KEYS = ['size', 'length', 'wmin', 'wmax'];
  function fmtSize(z) { return String(z).replace('.5', '½'); }
  function list(card, attr) { return (card.getAttribute(attr) || '').split(',').filter(function (x) { return x !== ''; }); }
  function fitFilter(root) {
    if (root.getAttribute('data-size-mode') !== 'client') return;
    var size = current.get('size');
    var len = current.get('length');
    var wmin = parseFloat(current.get('wmin'));
    var wmax = parseFloat(current.get('wmax'));
    if (size && !/^\d{1,2}(\.5)?$/.test(size)) size = null;
    if (len && !/^\d{1,2}$/.test(len)) len = null;
    var hasW = !isNaN(wmin) || !isNaN(wmax);
    if (!size && !len && !hasW) return;
    var grid = root.querySelector('[data-wr-grid]');
    if (!grid) return;

    var parts = [];
    if (size) parts.push('Size ' + fmtSize(size));
    if (len) parts.push(len + ' in');
    if (hasW) {
      if (isNaN(wmin)) parts.push('up to ' + wmax + 'mm');
      else if (isNaN(wmax)) parts.push(wmin + 'mm+');
      else parts.push(wmin === wmax ? wmin + 'mm' : wmin + '–' + wmax + 'mm');
    }
    var label = parts.join(' · ');
    var clearUrl = new URL(window.location.href);
    FIT_KEYS.forEach(function (k) { clearUrl.searchParams.delete(k); });
    var clearHref = clearUrl.pathname + clearUrl.search + '#shop';

    var pill = root.querySelector('[data-wr-size-pill]');
    if (pill) {
      Array.prototype.slice.call(pill.childNodes).forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim() === 'Size') n.textContent = ''; });
      pill.hidden = false;
    }
    qsa('[data-wr-size-label]', root).forEach(function (el) { el.textContent = label; });
    qsa('[data-wr-size-pill], [data-wr-size-clear]', root).forEach(function (el) { el.setAttribute('href', clearHref); });
    var emptyH = root.querySelector('[data-wr-size-empty] .wr-h3');
    if (emptyH) emptyH.textContent = 'Nothing in ' + label + ' right now.';

    /* keep the size / fit choice while changing other filters */
    qsa('a[href]', root).forEach(function (a) {
      if (a.hasAttribute('data-wr-size-pill') || a.hasAttribute('data-wr-size-clear')) return;
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) === '#') return;
      var u = new URL(h, window.location.origin);
      if (u.origin !== window.location.origin || u.pathname !== window.location.pathname) return;
      FIT_KEYS.forEach(function (k) { if (current.get(k)) u.searchParams.set(k, current.get(k)); });
      a.setAttribute('href', u.pathname + u.search + u.hash);
    });
    qsa('[data-wr-filters]', root).forEach(function (form) {
      FIT_KEYS.forEach(function (k) {
        if (!current.get(k)) return;
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = k; input.value = current.get(k);
        form.appendChild(input);
      });
    });

    function matches(card) {
      if (size && list(card, 'data-sizes').indexOf(size) < 0) return false;
      if (len && list(card, 'data-lengths').indexOf(len) < 0) return false;
      if (hasW) {
        var ok = list(card, 'data-widths').some(function (x) {
          var w = parseFloat(x);
          return !isNaN(w) && (isNaN(wmin) || w >= wmin - 0.001) && (isNaN(wmax) || w <= wmax + 0.001);
        });
        if (!ok) return false;
      }
      return true;
    }
    function apply() {
      var shown = 0;
      qsa('.wr-card', grid).forEach(function (card) {
        var m = matches(card);
        card.hidden = !m;
        if (m) shown++;
      });
      qsa('.wr-promo', grid).forEach(function (el) { el.hidden = true; });
      var empty = root.querySelector('[data-wr-size-empty]');
      if (empty) empty.hidden = shown > 0;
      grid.hidden = shown === 0;
      grid.removeAttribute('aria-busy');
    }
    function loadAll() {
      var btn = root.querySelector('[data-wr-load-more]');
      if (!btn || !window.fetch || !window.DOMParser) return Promise.resolve();
      return loadNext(root, btn).then(function (more) { return more ? loadAll() : null; });
    }
    root.classList.add('is-size-filtered');
    grid.setAttribute('aria-busy', 'true');
    var wrap = root.querySelector('[data-wr-more-wrap]');
    if (wrap) wrap.hidden = true;
    apply();
    loadAll().then(apply, apply);
  }

  function init(root) {
    if (!root || root.getAttribute('data-wr-ready') === 'true') return;
    root.setAttribute('data-wr-ready', 'true');
    stockDefault(root);
    keepView(root);
    bindStockToggles(root);
    bindSort(root);
    bindFilters(root);
    bindDrawer(root);
    bindLoadMore(root);
    fitFilter(root);
  }

  function initAll() {
    qsa('[data-wr-shop]').forEach(init);
    if (VIEW) qsa('.wr-houses, [data-wr-keep-view]').forEach(keepView);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { qsa('[data-wr-shop]', e.target).forEach(init); });
})();